// Components
import { ButtonColor, ButtonSize, ButtonVariant } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import Text, { TextVariant } from 'src/components/atoms/Text';
import {
  Container,
  ContentWrapper,
  IllustrationContainer,
  LeftSection,
  RightSection,
  StyledButton
} from './styles';

const RentVerificationEmpty: React.FC = () => {
  const handleRequestInfo = () => {
    window.open('https://snappt.com/verification-of-rent/', '_blank');
  };

  return (
    <Container>
      <LeftSection>
        <ContentWrapper>
          <Text variant={TextVariant.h1} style={{ fontWeight: 'lighter' }}>
            Verification of Rent is here.
          </Text>
          <Text>
            Everything you need to streamline approvals, reduce risk, and boost leasing confidence.
          </Text>

          <StyledButton
            name="request-info-button"
            variant={ButtonVariant.contained}
            color={ButtonColor.primary}
            size={ButtonSize.normal}
            label="Request Info"
            onClick={handleRequestInfo}
          >
            Request Info
            <Icon icon="arrow-right" />
          </StyledButton>
        </ContentWrapper>
      </LeftSection>
      <RightSection>
        <IllustrationContainer>
          <img
            src="/assets/images/rent-verification-empty.svg"
            alt="No rent verifications available"
          />
        </IllustrationContainer>
      </RightSection>
    </Container>
  );
};

export default RentVerificationEmpty;
